import * as React from 'react';

import { ModalContext } from '@notino/react-styleguide';

import { DrawerProvider } from '@components/BottomSheet/DrawerProvider';

import { WishlistPager } from './components/WishlistPager';
import { trackWishlistPageView } from './components/WishlistPager/tracking';
import { PRODUCTS_PER_PAGE } from './constants';
import { WishlistContainer, LoadingContainer } from './styled';
import { useWishlistForLoggedUserOrOwner } from './useWishlistForLoggedUserOrOwner';

export interface WishlistProps {
  data?: {
    owner?: string; // if wishlist id ('owner') is not provided, logged user's wishlist is fetched
  };
}

const WishList: React.FC<WishlistProps> = ({ data }) => {
  const { productIds, loading, owner, userId } =
    useWishlistForLoggedUserOrOwner(data?.owner);

  // useLayoutEffect is used for tracking the page_view event to ensure the effect runs
  // before the children render, because their useEffect hooks might run after the render.
  React.useLayoutEffect(() => {
    trackWishlistPageView();
  }, []);

  return (
    <DrawerProvider>
      <ModalContext.Provider>
        <WishlistContainer>
          {loading ? (
            <LoadingContainer />
          ) : (
            <WishlistPager
              pageSize={PRODUCTS_PER_PAGE}
              owner={owner}
              productIds={productIds}
              userId={userId}
            />
          )}
        </WishlistContainer>
      </ModalContext.Provider>
    </DrawerProvider>
  );
};

export default WishList;
